// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { UserDetailsData, UserState } from './user-details/user-details.interfaces';
import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { State, selectUsers, LoadingUsersAction } from '@app/access-management/state';
import { Observable } from 'rxjs';
import { Loadable, needsLoading, Loaded, IAMUser, MaybeLoadable, LoadingStatus, GoAction} from '@app/core';
import { take, filter, map } from 'rxjs/operators';
import { SelectUserAction } from './user-details/user-details.actions';

const shouldLoadUsers = (users: MaybeLoadable) => needsLoading<Loaded<IAMUser[]>>(users);
const hasUsersState = (users: MaybeLoadable) => !needsLoading<Loaded<IAMUser[]>>(users);

@Injectable({providedIn: 'root'})
export class UsersFacadeService {

    loadableUsers$: Observable<Loaded<IAMUser[]> | Loadable> = this.store.pipe(select(selectUsers));
    users$: Observable<IAMUser[]> = this.loadableUsers$.pipe(
            filter<Loaded<IAMUser[]> | Loadable>(hasUsersState),
            map(userList => userList.data)
        );

    constructor(private store: Store<State>) {}

    initialize () {
        this.loadableUsers$.pipe(take(1), filter(shouldLoadUsers))
          .subscribe(() => this.store.dispatch(new LoadingUsersAction()));
    }

    selectUser(user: UserState) {
        this.store.dispatch(new SelectUserAction(user));
        this.store.dispatch(new GoAction(['/iam/users', user.username]));
    }
}




// WEBPACK FOOTER //
// ./src/app/access-management/state/users.facade.ts